import { useEffect } from "react";

const DashBoardRedirect = () => {
  useEffect(() => {
    window.location.href = `${process.env.REACT_APP_strapiUrl}/admin/content-manager`;
  }, []);
  return null;
};

export default DashBoardRedirect;
